import {createAction, createSlice} from "@reduxjs/toolkit"


const initialState = {
    byDates:{
        isPending: false,
        error: null,
        items:[],
        // item:{},
    },
    byDeviceIds:{
        isPending: false,
        error: null,
        items:[],
        // item:{},
    },
    statsCount:{
        isPending: false,
        error: null,
        items:[],
        item:{},
    },
    statsRegions:{
        isPending: false,
        error: null,
        items:[],
        item:{},
    },
    statsMeanStopTimeMinutes:{
        isPending: false,
        error: null,
        items:[],
        item:{},
    },
    reportRegionsCsv:{
        isPending: false,
        error: null,
    },
    reportCountPerHourCsv:{
        isPending: false,
        error: null,
    },
}

const slice = createSlice({
    name: 'licenseplates',
    initialState,
    reducers:{
        // byDates
        fetchLicencePlatesByDates:(state,{payload})=>{
            state.byDates.isPending = true;
            state.byDates.items = initialState.byDates.items;
        },
        fetchLicencePlatesByDatesSuccess:(state,{payload})=>{
            state.byDates.error = null;
            state.byDates.items = payload;
            state.byDates.isPending = false;
        },
        fetchLicencePlatesByDatesFailure:(state,{payload})=>{
            state.byDates.error = payload;
            state.byDates.isPending = false;
        },

        // byDeviceIds
        fetchLicencePlatesByDeviceIds:(state,{payload})=>{
            state.byDeviceIds.isPending = true;
            state.byDeviceIds.items = initialState.byDeviceIds.items;
        },
        fetchLicencePlatesByDeviceIdsSuccess:(state,{payload})=>{
            state.byDeviceIds.error = null;
            state.byDeviceIds.items = payload;
            state.byDeviceIds.isPending = false;
        },
        fetchLicencePlatesByDeviceIdsFailure:(state,{payload})=>{
            state.byDeviceIds.error = payload;
            state.byDeviceIds.isPending = false;
        },

        // statsCount
        fetchLicencePlatesStatsCount:(state,{payload})=>{
            state.statsCount.isPending = true;
            state.statsCount.items = initialState.statsCount.items;
            state.statsCount.item = initialState.statsCount.item;
        },
        fetchLicencePlatesStatsCountSuccess:(state,{payload})=>{
            state.statsCount.error = null;
            state.statsCount.items = payload;
            state.statsCount.isPending = false;
        },
        fetchLicencePlatesStatsCountFailure:(state,{payload})=>{
            state.statsCount.error = payload;
            state.statsCount.isPending = false;
        },

        // statsRegions
        fetchLicencePlatesStatsRegions:(state,{payload})=>{
            state.statsRegions.isPending = true;
            state.statsRegions.items = initialState.statsRegions.items;
            state.statsRegions.item = initialState.statsRegions.item;
        },
        fetchLicencePlatesStatsRegionsSuccess:(state,{payload})=>{
            state.statsRegions.error = null;
            state.statsRegions.items = payload;
            state.statsRegions.isPending = false;
        },
        fetchLicencePlatesStatsRegionsFailure:(state,{payload})=>{
            state.statsRegions.error = payload;
            state.statsRegions.isPending = false;
        },

        // statsMeanStopTimeMinutes
        fetchLicencePlatesStatsMeanStopTimeMinutes:(state,{payload})=>{
            state.statsMeanStopTimeMinutes.isPending = true;
            state.statsMeanStopTimeMinutes.items = initialState.statsMeanStopTimeMinutes.items;
            state.statsMeanStopTimeMinutes.item = initialState.statsMeanStopTimeMinutes.item;
        },
        fetchLicencePlatesStatsMeanStopTimeMinutesSuccess:(state,{payload})=>{
            state.statsMeanStopTimeMinutes.error = null;
            state.statsMeanStopTimeMinutes.items = payload;
            state.statsMeanStopTimeMinutes.isPending = false;
        },
        fetchLicencePlatesStatsMeanStopTimeMinutesFailure:(state,{payload})=>{
            state.statsMeanStopTimeMinutes.error = payload;
            state.statsMeanStopTimeMinutes.isPending = false;
        },

        // reportRegionsCsv
        fetchLicencePlateReportRegionsCsv:(state)=>{
            state.reportRegionsCsv.isPending = true;
            state.reportRegionsCsv.error = null;
        },
        fetchLicencePlateReportRegionsCsvSuccess:(state)=>{
            state.reportRegionsCsv.isPending = false;
        },
        fetchLicencePlateReportRegionsCsvFailure:(state,{payload})=>{
            state.reportRegionsCsv.error = payload;
            state.reportRegionsCsv.isPending = false;
        },

        // reportCountPerHourCsv
        fetchLicencePlateReportCountPerHourCsv:(state)=>{
            state.reportCountPerHourCsv.isPending = true;
            state.reportCountPerHourCsv.error = null;
        },
        fetchLicencePlateReportCountPerHourCsvSuccess:(state)=>{
            state.reportCountPerHourCsv.isPending = false;
        },
        fetchLicencePlateReportCountPerHourCsvFailure:(state,{payload})=>{
            state.reportCountPerHourCsv.error = payload;
            state.reportCountPerHourCsv.isPending = false;
        },
    }
});


export const licenseplatesActions = slice.actions;

export default slice.reducer;